// extracted by mini-css-extract-plugin
export var base = "_2v-0";
export var updateBanner = "_2v-1";